import { render, staticRenderFns } from "./CustomerBusinessCard.vue?vue&type=template&id=67672c02&scoped=true"
import script from "./CustomerBusinessCard.vue?vue&type=script&lang=ts"
export * from "./CustomerBusinessCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67672c02",
  null
  
)

export default component.exports